var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3585 0.572915C14.2208 0.483554 14.0669 0.422196 13.9055 0.392344C13.7441 0.362493 13.5784 0.364733 13.4178 0.398938C13.2573 0.433143 13.1051 0.498642 12.9698 0.591693C12.8346 0.684745 12.7191 0.803525 12.6298 0.941249L5.62559 11.7375L2.20976 8.57917C2.08924 8.46773 1.94796 8.38113 1.79397 8.3243C1.63999 8.26747 1.47632 8.24152 1.31231 8.24795C0.981069 8.26092 0.668553 8.40494 0.443505 8.64833C0.218458 8.89172 0.0993151 9.21455 0.112286 9.54578C0.125258 9.87702 0.269281 10.1895 0.512672 10.4146L4.99767 14.5612C4.99767 14.5612 5.12642 14.6721 5.18601 14.7108C5.32371 14.8003 5.47768 14.8617 5.63913 14.8916C5.80058 14.9214 5.96633 14.9192 6.12692 14.885C6.28751 14.8508 6.43978 14.7853 6.57503 14.6922C6.71029 14.5991 6.82587 14.4803 6.91517 14.3425L14.7268 2.30167C14.8162 2.16398 14.8776 2.01004 14.9074 1.84863C14.9373 1.68723 14.935 1.52152 14.9008 1.36098C14.8666 1.20044 14.8011 1.04822 14.7081 0.912998C14.615 0.777779 14.4962 0.662217 14.3585 0.572915Z",
    fill: "#31AD31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelector);
export default __webpack_public_path__ + "static/media/selector.da34a1dd4adadf87a17cced94304cca0.svg";
export { ForwardRef as ReactComponent };